/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactInput/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ContactMethodConsent from './ContactMethodConsent/index'
import ContactMethodMarketing from './ContactMethodMarketing/index'
import EmailInput from './EmailInput/index'
import PhoneInput from './PhoneInput/index'
import PhoneTypeToggle from './PhoneTypeToggle/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import UsePatientValue from './UsePatientValue/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ContactInput({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ContactInput"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtCheckboxStrokeBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.stroke.brand.selected'
        })
let dtCheckboxBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.backgroundColor.brand.selected'
        })
let dtCheckboxBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.selected'
        })
let dtCheckboxBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.hovered'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onKeyUp = fromHelpers.useOnKeyUp({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<PhoneInput
  viewPath={`${viewPath}/PhoneInput`}
/>
<div
  data-testid="ContactInput.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-1FFIUj': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Providing your phone number does not automatically enroll you in SMS messages. SMS consent is optional and is not required to submit this form or receive services."
/>
</div>
<UsePatientValue
  viewPath={`${viewPath}/UsePatientValue`}
 strokeSelected={dtCheckboxStrokeBrandSelected}
 backgroundColorSelected={dtCheckboxBackgroundcolorBrandSelected}
 borderColorSelected={dtCheckboxBordercolorBrandSelected}
 borderColorHovered={dtCheckboxBordercolorBrandHovered}
/>
<PhoneTypeToggle
  viewPath={`${viewPath}/PhoneTypeToggle`}
/>
<EmailInput
  viewPath={`${viewPath}/EmailInput`}
/>
<div
  data-testid="ContactInput.Vertical:1"
  data-view-path={viewPath}
 onKeyUp={onKeyUp}
 style={{'--mt-1-1FFIUj': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<ContactMethodConsent
  viewPath={`${viewPath}/ContactMethodConsent`}
/>
<ContactMethodMarketing
  viewPath={`${viewPath}/ContactMethodMarketing`}
/>
</div>
{children}
</React.Fragment>)
}